import type { Components, Theme } from "@mui/material/styles";

export const MuiAlertTitle: Components<Theme>["MuiAlertTitle"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontSize: theme.spacing(2),
      lineHeight: 1.5,
      fontWeight: 500,
    }),
  },
};
